<!--
 * @Description:
 * @Author: yunhe
 * @Date: 2020-10-22 12:21:16
 * @LastEditors: yunhe
 * @LastEditTime: 2020-10-22 12:26:31
-->
<template>
  <div class="input-phone pink-border">
    <img
      class="input-phone__text"
      src="../assets/text1.png">
    <img
      class="input-phone__charge"
      src="../assets/telephone-charge.png">
    <input
      v-model="phoneNum"
      placeholder="请输入手机号码"/>
    <img
      class="input-phone__btn"
      @click="save"
      src="../assets/btn1.png">
    <slot/>
  </div>
</template>
<script>
export default {
  name: 'InputPhone',
  data () {
    return {
      phoneNum: ''
    }
  },
  methods: {
    save () {
      let reg = /1\d{10}/
      if (reg.test(this.phoneNum)) {
        this.$emit('receive', this.phoneNum)
      } else {
        this.phoneNum = ''
        this.$message('手机号码格式不正确，请重新输入！')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InputDialog.vue